import { apiClient, type ItemUnitExEntity } from '@/libs/api'

export type FetchItemUnitQuery = {
  tenantKey: string
  itemUnitId: number
}

export type FetchItemUnitResponse = {
  data: ItemUnitExEntity
}

export const fetchItemUnit = async (
  { tenantKey, itemUnitId }: FetchItemUnitQuery,
  signal?: AbortSignal
): Promise<FetchItemUnitResponse> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .item_units._id(itemUnitId)
    .$get({
      config: {
        signal
      }
    })
  return { data }
}
